import { VendorRentalPaymentPrintPage } from "@/features/vendor-app/pages/VendorRentalPaymentPrintPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/rental/$vendorConsignmentRentalPaymentID/print",
)({
	component: VendorRentalPaymentPrintPage,
});
